// extracted by mini-css-extract-plugin
module.exports = {"ssrGrid":"HorizontalItemScroller_ssrGrid__CtG7_","chevronGroup":"HorizontalItemScroller_chevronGroup__S2BWM","chevronCircle":"HorizontalItemScroller_chevronCircle__nPhWH"};